import { ReactElement, useMemo } from 'react';

import { Textarea } from '@dreryk/react-components';
import { FormContextValues } from '@dreryk/react-common';

import { patientMedicalInformationTranslationKeys } from '../../translations';

import { MedicalInformationAttachmentMarkAsRemovedFormBean } from './MedicalInformationAttachmentMarkAsRemovedForm.types';

export const MedicalInformationAttachmentMarkAsRemovedFormDescriptionField = (
   props: Pick<FormContextValues<MedicalInformationAttachmentMarkAsRemovedFormBean>, 'register' | 'watch'>
): ReactElement | null => {
   const reason = props.watch('reason');
   const showDescription = useMemo(() => {
      return reason === 'OTHER';
   }, [reason]);
   return showDescription ? (
      <Textarea
         testId={'description'}
         controller={props.register('description', { required: true })}
         placeholder={
            patientMedicalInformationTranslationKeys.previewModal.markAsRemovedAttachmentModal.reason
               .descriptionPlaceholder
         }
         rows={4}
         maxRows={4}
         maxLength={200}
      />
   ) : null;
};
